import React from 'react';
import { actions } from '../constants';
import { SingleFormWithUpdate } from './SingleFormWithUpdate';
import { IRecipeEditable } from '../../../types/recipes-types';
import { IDbCycleSettings } from '../../../store/models/cycles';
import { IOnUpdateSettingField } from '../PostWeldSettings';
import CycleMeasurement from '../../../enums/cycle-measurement';
import CycleMeasurementSymbol from '../../../enums/cycle-measurement-symbol';
import { createPostWeldRecipeFieldValidationSchema } from '../../../utils/recipe-unit-validation';

export interface RecipeUpdateFieldsProps {
  onUpdateSettings: (data: IOnUpdateSettingField) => any;
  settings: IDbCycleSettings;
  initialSettings: IRecipeEditable;
  setInitialSettings: (state: IRecipeEditable) => any;
  measurement: CycleMeasurement;
  controllerMeasurement?: CycleMeasurement | null;
}

export const RecipeUpdateFields = ({
  onUpdateSettings,
  settings,
  initialSettings,
  setInitialSettings,
  measurement,
  controllerMeasurement,
}: RecipeUpdateFieldsProps) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>, key: keyof IRecipeEditable) => {
    const type = event.target.type as React.InputHTMLAttributes<HTMLInputElement>['type'];
    const inputValue = event.target.value;
    const value = type === 'number' ? +inputValue : inputValue;

    setInitialSettings({ ...initialSettings, [key]: value });
  };

  const getFieldLabel = (item: (typeof actions)[number]) => {
    const symbol = CycleMeasurementSymbol[measurement];
    const isRateField = item.editableKey === 'rateUpperTolerance' || item.editableKey === 'rateLowerTolerance';
    const isTemperatureField =
      isRateField || item.editableKey === 'holdUpperTolerance' || item.editableKey === 'holdLowerTolerance';

    if (!isTemperatureField) {
      return item.labelText;
    }

    return `${item.labelText} (${isRateField ? `${symbol}/h` : symbol})`;
  };

  return actions.map((item) => {
    return (
      <SingleFormWithUpdate
        key={item.actionName}
        type={item.inputType}
        values={{
          [item.actionField]: initialSettings[item.editableKey],
        }}
        label={getFieldLabel(item)}
        currentValues={settings[item.actionField]}
        onChange={(e) => onChangeHandler(e, item.editableKey)}
        onSubmit={(val) =>
          onUpdateSettings({ action: item.actionName, key: item.editableKey, value: String(val[item.actionField]) })
        }
        validationSchema={createPostWeldRecipeFieldValidationSchema(measurement, item.actionField, item.editableKey, controllerMeasurement)}
      />
    );
  });
};
